import TripCheckoutBookOrHoldModule from './trip-checkout-book-or-hold/trip-checkout-book-or-hold-module';
import TripCheckoutPaymentModule from './../payment/trip-checkout-payment-module';
import TripCheckoutService from './trip-checkout-service';

const MODULE_NAME = 'app.trip.checkout';
const module = angular.module(MODULE_NAME, [
    TripCheckoutBookOrHoldModule,
    TripCheckoutPaymentModule,
])
    .service('tripCheckoutService', TripCheckoutService);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/trip/checkout/trip-checkout-module.js